import React from 'react';
import { X } from 'lucide-react';

const DischargeModal = ({ isOpen, onClose, isLoading, dischargeFormData, setDischargeFormData, onSubmit }) => {
  if (!isOpen) return null;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setDischargeFormData({
      ...dischargeFormData,
      [name]: value
    });
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
        <div className="flex justify-between items-center px-6 py-4 border-b border-gray-200">
          <h2 className="text-lg font-semibold">Discharge Patient</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-500 focus:outline-none"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
        <form onSubmit={onSubmit} className="px-6 py-4">
          <div className="space-y-4">
            <div>
              <label htmlFor="discharge_reason" className="block text-sm font-medium text-gray-700">
                Discharge Reason
              </label>
              <select
                name="discharge_reason"
                id="discharge_reason"
                value={dischargeFormData.discharge_reason}
                onChange={handleInputChange}
                className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                required
                disabled={isLoading}
              >
                <option value="">Select reason</option>
                <option value="Normal Discharge">Normal Discharge</option>
                <option value="Transferred to Another Facility">Transferred to Another Facility</option>
                <option value="Patient Passed away">Patient Passed away</option>
                <option value="other">Others</option>
              </select>

              {dischargeFormData.discharge_reason === 'other' && (
                <div className="mt-2">
                  <label htmlFor="other_reason" className="block text-sm font-medium text-gray-700">
                    Please specify
                  </label>
                  <input
                    type="text"
                    name="other_reason"
                    id="other_reason"
                    value={dischargeFormData.other_reason || ''}
                    onChange={handleInputChange}
                    className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                    required
                    disabled={isLoading}
                  />
                </div>
              )}
            </div>
            <div>
              <label htmlFor="discharged_on" className="block text-sm font-medium text-gray-700">
                Discharge Date
              </label>
              <input
                type="date"
                name="discharged_on"
                id="discharged_on"
                value={dischargeFormData.discharged_on}
                onChange={handleInputChange}
                className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                required
                disabled={isLoading}
              />
            </div>
          </div>
          <div className="mt-6 flex justify-end space-x-3">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              disabled={isLoading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 flex items-center justify-center"
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <svg className="animate-spin h-5 w-5 mr-2 text-white" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Discharging...
                </>
              ) : (
                'Discharge'
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default DischargeModal;